export default __webpack_public_path__ + "d6aa083e303960bc7ce33b96954fb9b4.png";